module.exports = __webpack_public_path__ + "img/help-icon-light.28ff8b95.png";